import api from '../api';

import { ParamsBodyGetListStoresByZipCode, ParamsDataListStoresByZipCode } from 'utils/typeServices';

export const PostGetListStoresByZipCode = async ({ token, body }: { token: string, body: ParamsBodyGetListStoresByZipCode }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<Array<ParamsDataListStoresByZipCode>>('v1/Agendamento/GetListStoresByZipCode', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
